import type { RouterConfig } from '@nuxt/schema'

export default <RouterConfig>{
  scrollBehavior(to, from, savedPosition) {
    if (to.path === from.path) {
      // A link to part of the same page has nothing new to wait for
      if (to.hash && to.hash !== from.hash) document.querySelector(to.hash)?.scrollIntoView({ behavior: 'smooth' })

      // Changing only the query, like switching tabs, keeps the page where it is
      return false
    }

    const nuxtApp = useNuxtApp()

    // Waits for the new page, so the old one doesn't jump before it's replaced
    return new Promise((resolve) => {
      nuxtApp.hooks.hookOnce('page:finish', () => {
        requestAnimationFrame(() => {
          const target = to.hash ? document.querySelector(to.hash) : null

          if (target) {
            target.scrollIntoView()
          } else {
            // Back and forward return to where the page was left, as browsers do
            getScrollContainer()?.scrollTo({ top: savedPosition ? scrollPositions.get(to.fullPath) ?? 0 : 0 })
          }

          resolve(false)
        })
      })
    })
  }
}
